import { Component, OnInit, Input, OnChanges, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-authentication-setup',
  templateUrl: './authentication-setup.component.html',
  styleUrls: ['./authentication-setup.component.scss'],
})
export class AuthenticationSetupComponent implements OnInit, OnChanges {
  @Input() methods;
  @Output() authSetup = new EventEmitter();
  @ViewChildren('li') liMFA: QueryList<any> | undefined;

  allowedMFA: any = [];
  allowedMethods: any;
  initial_state:boolean = true;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    if (this.methods) {
      this.allowedMethods = this.methods;
    }
  }

  _selectAuthentication = (method, event) =>{
    this._changeSelection(event);
    this.authSetup.emit(method);
  }

  _changeSelection = (event: any) => {
    this.initial_state = false;
    this.liMFA?.forEach((liv) => {
      liv.nativeElement.firstChild.firstChild.classList.remove('active');
    });
    event.target.classList.add('active');
  };
}
